import { t } from 'ttag';

import { captureException } from 'lib/sentry';

export function getIsJoinEmployeeFlow() {
  return window.location.pathname.startsWith('/app/onboarding');
}

export enum EmployeeGender {
  Male = 'male',
  Female = 'female',
}

export enum JoinEmployeeFlowStep {
  PersonalData = 'PersonalData',
  FamilyStatus = 'FamilyStatus',
  Children = 'Children',
  PassportData = 'PassportData',
  RegistrationAddress = 'RegistrationAddress',
  ResidenceAddress = 'ResidenceAddress',
  Education = 'Education',
  MilitaryRegistration = 'MilitaryRegistration',
  SocialStatuses = 'SocialStatuses',
  DocumentCopies = 'DocumentCopies',
}

const JOIN_EMPLOYEE_FLOW_STEP_LOCALIZATION: Map<JoinEmployeeFlowStep, string> =
  new Map([
    [JoinEmployeeFlowStep.PersonalData, t`Особисті дані`],
    [JoinEmployeeFlowStep.FamilyStatus, t`Сімейний стан`],
    [JoinEmployeeFlowStep.Children, t`Сімейний стан`],
    [JoinEmployeeFlowStep.PassportData, t`Паспортні дані`],
    [JoinEmployeeFlowStep.RegistrationAddress, t`Адреса реєстрації`],
    [JoinEmployeeFlowStep.ResidenceAddress, t`Фактична адреса проживання`],
    [JoinEmployeeFlowStep.Education, t`Інформація про освіту`],
    [JoinEmployeeFlowStep.MilitaryRegistration, t`Військовий облік`],
    [JoinEmployeeFlowStep.SocialStatuses, t`Соціальні статуси`],
    [JoinEmployeeFlowStep.DocumentCopies, t`Копії документів`],
  ]);

export function localizeJoinEmployeeStep(step: JoinEmployeeFlowStep): string {
  if (!JOIN_EMPLOYEE_FLOW_STEP_LOCALIZATION.has(step)) {
    captureException(new Error(`No localization found for step`), {
      step,
    });

    return String(step);
  }

  return JOIN_EMPLOYEE_FLOW_STEP_LOCALIZATION.get(step)!;
}
